import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import MatriculeTableauBord from '../Graph/MatriculeTableauBordCumul.js';
import { rescueHtml } from '../Components/Tools.js';

const Page3RecettesFct = (props) => {
    const blue = '#069BD3';

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>

            {/* Header */}
            <div style={{display: 'flex'}}>
                <div style={{margin: 25}}>
                    <img style={{width: 200}} src={Logo} />
                </div>

                <div style={{flex: 1}}></div>
                
                <div style={{margin: 25}}>
                    <p style={{color: blue, fontSize: 24}}>{rescueHtml(props.user.nom_organisme)}</p>
                </div>
            </div>

            <div style={{borderBottom: '1px solid '+blue, marginLeft: 25, display: 'flex', alignItems: 'center'}}>
                <p style={{color: blue, fontSize: 26}}>{props.titre}</p>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%'}}>
                <div style={{flex: 1, display: 'flex', marginLeft: 25, marginRight: 25, marginTop: 15}}>
                {props.objet.map((annee) => 
                parseInt(annee) == parseInt(props.year)?
                annee[1].map((line, j) =>
                    line[0] === '2014M57REELCREFCT' || line[0] === '2014M5773' || line[0] === '2014M5774'?
                    <div key={j} style={{flex: 1}}>
                        <MatriculeTableauBord user={props.user} annee={annee[0]} intitule={line[1]['intitule'] + (line[1]['compte'] != ''?' ('+line[1]['compte']+')':'')} grille={annee[1][j]} color={j===9?'#27ae60':j===11?'#e67e22':'#f1c40f'}/>
                    </div>
                    :null)
                :null)}
                </div>
                <div style={{flex: 1, display: 'flex', marginLeft: 25, marginRight: 25, marginTop: 5}}>
                {props.objet.map((annee) => 
                parseInt(annee) == parseInt(props.year)?
                annee[1].map((line, j) =>
                    line[0] === '2014M5770' || line[0] === '2014M5775' || line[0] === '2014M57775'?
                    <div key={j} style={{flex: 1}}>
                        <MatriculeTableauBord user={props.user} annee={annee[0]} intitule={line[1]['intitule'] + (line[1]['compte'] != ''?' ('+line[1]['compte']+')':'')} grille={annee[1][j]} color={j===10?'#c0392b':j===13?'#3498db':'#2c3e50'}/>
                    </div>
                    :null)
                :null)}
                </div>
            </div>


            {/* Footer */}
            <div style={{display: 'flex', marginBottom: 15}}>
                <div style={{marginLeft: 25}}>
                    <p style={{fontSize: 10}}>{props.date}</p>
                </div>
                <div style={{flex: 1}}></div>
                <div style={{marginRight: 25}}>
                    <p style={{fontSize: 10}}>Page : {props.index}</p>
                </div>
            </div>
        </div>
    );
};

export default Page3RecettesFct;
